import script from "./CodeValidation.vue?vue&type=script&lang=ts&setup=true"
export * from "./CodeValidation.vue?vue&type=script&lang=ts&setup=true"

import "./CodeValidation.vue?vue&type=style&index=0&id=52b592ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b592ce"]])

export default __exports__